<template>
  <div class="cash-header">
    <div class="award-wrap">
      <div class="award-pic" :class="payType"></div>
      <div class="award-name">{{ decodeURIComponent(productDesc) }}</div>
      <div class="award-order">{{ letter.reference }} {{ orderId }}</div>
    </div>
    <div class="award-amount">{{ getMoneyWithUnit }}</div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
      orderId: state => state.cash.order_id,
      productDesc: state => state.cash.product_desc,
      payType: state => state.cash.pay_type
    }),
    ...mapGetters(['getMoneyWithUnit'])
  },
};
</script>
<style lang="scss" scoped>
$img: '~@assets/image/cash/';
.cash-header {
  display: flex;
  justify-content: space-between;
  .award-wrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .award-pic {
      width: 90px;
      height: 60px;
      background: url($img + 'card.svg') no-repeat;
      background-size: contain !important;
      background-position: center center !important;
      border-radius: 10px;
      &.visa {
        background: url($img + 'card-icons/visa.png') no-repeat;
      }
      &.master {
        background: url($img + 'card-icons/mc.png') no-repeat;
      }
      &.jcb {
        background: url($img + 'card-icons/JCB-SSL.png') no-repeat;
      }
      &.discover {
        background: url($img + 'card-icons/DISCOVER-SSL.png') no-repeat;
      }
      &.amex {
        background: url($img + 'card-icons/amex.png') no-repeat;
      }
      &.diners {
        background: url($img + 'card-icons/diners club.svg') no-repeat;
      }
    }
    .award-name {
      font-size: 14px;
      color: #00112c;
      margin-top: 5px;
    }
    .award-order {
      font-size: 12px;
      color: #687282;
      margin-top: 8px;
    }
  }
  .award-amount {
    font-size: 22px;
    color: #00112c;
    font-weight: 600;
  }
}
</style>
